// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"6e2e5643","314":"6ecdaa08","574":"06be75ae","787":"0338cd24"}[chunkId] + ".chunk.js";
};